import * as myaccount from '@myaccount/pre-integrated-feature';
import * as modals from '@myaccount/modals';
import { renderers } from '@sitebase/pre-integrated-header/default-features';
import FeedbackRenderer from './components/FeedbackRenderer';
import OddsRenderer from './components/OddsRenderer';
import RadioRenderer from './components/RadioRenderer';
import MediaRenderer from './components/MediaRenderer';
import SettingsRenderer from './components/SettingsRenderer';
import LinkRenderer from './components/LinkRenderer';
import NestedLanguageMenuRenderer from './components/languageMenu/NestedLanguageMenuRenderer';
import LanguageMenuRenderer from './components/languageMenu/LanguageMenuRenderer';
import SearchRenderer from './components/SearchRenderer';

export default [
  ...renderers,
  FeedbackRenderer,
  OddsRenderer,
  RadioRenderer,
  MediaRenderer,
  SettingsRenderer,
  LinkRenderer,
  NestedLanguageMenuRenderer,
  LanguageMenuRenderer,
  SearchRenderer,
  ...myaccount.renderers,
  modals.modals,
];
